function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { EHeliMicPermissionState } from '../IHeliNetwork';
import Peer from 'skyway-js';
import { CHELSkywayPlayer } from './CHELSkyPlayer';
import { HEL_AUDIO_TYPE_VOICE, worldViewerWindow } from '../../const';
import { debugLog } from '../../debugLog';
import { helcore_video_play } from '../../heliodor_core_video_callee';
import { closeLocalStream, getLocalStream, getMixerRealSettingAt, getSkyRoomId, getSkywayKey, getSkywayName, getSkywayOnTellScreenShareStart, getSkywayOnTellWaitScreenShare, setLocalStream, getSkywayAvatarNumberForSend, getSkywayStartToggle, getSkywayUseCustomAvatarIcon, getSkywayCustomAvatarIconURL } from '../../logics/dataOps';
import { getVideo, setVideo } from '../../logics/domOps';
import { g_useVideoStreamFlag, videoStreams } from '../../heliodor_skyway';
export class CHeliSkyway {
    // 接続
    async connect(configKey) {
        if (!navigator.mediaDevices) {
            debugLog('navigator.mediaDevices not found');
            return null;
        }
        // LocalStreamの取得
        const localStream = g_useVideoStreamFlag ? await CHeliSkyway.setLocalAudioStreamWithDummyVideoBy() : await CHeliSkyway.setLocalAudioStreamBy();
        // マイク許可状態の確認
        await this.checkMicPermissionState();
        // マイクが許可されていなければ以下の接続をおこなわない
        if (localStream == null || this.m_MicPermissionState != EHeliMicPermissionState.Granted) {
            closeLocalStream();
            return null;
        }
        // default mic mute
        worldViewerWindow.hel_skyway_set_mic_state(false);
        // Render local stream
        await CHeliSkyway.playLocalStream(localStream);
        //
        const peer = new Peer({
            key: configKey === undefined ? getSkywayKey() : configKey,
            debug: 0
        });
        this.setPeer(peer);
        peer.on('error', console.error);
        return this.getPeer();
    }
    disconnect() {
        this.leaveRoom();
        this.destroyPeer();
        closeLocalStream();
        CHeliSkyway.resetLocalStream();
    }
    isConnected() {
        const peer = this.getPeer();
        if (peer == null) return false;
        return true;
    }
    getPeerId() {
        const peer = this.getPeer();
        if (peer == null) return "";
        const id = peer.id !== undefined ? peer.id : '';
        return id;
    }
    setPeer(peer) {
        this.m_Peer = peer;
    }
    destroyPeer() {
        if (this.m_Peer == null) return;
        this.m_Peer.destroy();
        this.m_Peer = null;
    }
    // マイク許可状態
    getMicPermissionState() {
        return this.m_MicPermissionState;
    }
    async checkMicPermissionState() {
        const prevPermissionState = this.m_MicPermissionState;
        try {
            const permissionStatus = await navigator.permissions.query({
                name: 'microphone'
            });
            if (permissionStatus.state === 'denied') {
                this.m_MicPermissionState = EHeliMicPermissionState.Denied;
            } else if (permissionStatus.state === 'granted') {
                this.m_MicPermissionState = EHeliMicPermissionState.Granted;
            } else if (permissionStatus.state === 'prompt') {
                this.m_MicPermissionState = EHeliMicPermissionState.Prompt;
            } else {
                this.m_MicPermissionState = EHeliMicPermissionState.Prompt;
            }
        } catch (e) {
            // Firefoxでは'microphone'に対応していないので、LocalStreamの設定状態で判別する
            if (getLocalStream() !== undefined) {
                this.m_MicPermissionState = EHeliMicPermissionState.Granted;
            } else {
                this.m_MicPermissionState = EHeliMicPermissionState.Denied;
            }
        }
        // 状態変更によるコールバック呼び出し
        if (this.m_IHeliNetworkCallback != null && prevPermissionState != this.m_MicPermissionState) {
            this.m_IHeliNetworkCallback.OnChangedMicPermissionState(this.m_MicPermissionState);
        }
    }
    // ルーム
    joinRoom(roomid) {
        // const leaveTrigger = document.getElementById('js-leave-trigger');
        const remoteVideos = document.getElementById('js-remote-streams');
        // Note that you need to ensure the peer has connected to signaling server
        // before using methods of peer instance.
        const peer = this.getPeer();
        if (peer == null || !peer.open) {
            debugLog('peer not open');
            return;
        }
        //
        const localStream = getLocalStream();
        if (localStream === undefined) {
            debugLog('localStream is not exist');
            return;
        }
        // roomidにサブドメインを付加した名前を実際には利用する
        // これは異なるドメインで同一ワールド名だと同じroomidが取得できてしまうのを回避するための対策
        const roomIdWithSubDomain = CHeliSkyway.addSubDomainRoomId(roomid);
        //
        const room = peer.joinRoom(roomid, {
            mode: 'sfu',
            stream: localStream,
            videoReceiveEnabled: true
        });
        this.setSkywayRoom(room);
        room.once('open', ()=>{
            worldViewerWindow.hel_skyway_receive_data('open', peer.id, '');
            // to set my name
            worldViewerWindow.hel_skyway_receive_data('data', peer.id, 'name:' + getSkywayName());
            // send my name to old player
            this.sendMyPlayerInfoToAllPlayer();
        });
        room.on('peerJoin', (peerId)=>{
            this.createPlayer(peerId);
            // send my name to new player
            this.sendMyPlayerInfoToAllPlayer();
            // 新たにジョインしたプレイヤーに対して、既に画面共有していた場合はstreamを送る
            this.sendScreenShareStart();
        });
        // Render remote stream for new peer join in the room
        room.on('stream', async (stream)=>{
            this.setPlayerStream(stream);
            // 映像ストリームを含んでいた場合、再生可能にするため格納する
            const remoteVideoStreamTracks = stream.getVideoTracks();
            if (remoteVideoStreamTracks.length > 0) {
                const remoteVideoStream = new MediaStream(remoteVideoStreamTracks);
                // @ts-ignore
                const peerId = stream.peerId || stream.id;
                videoStreams.set(peerId, remoteVideoStream);
            }
            const newAudio = document.createElement('audio');
            newAudio.srcObject = stream;
            newAudio.playsInline = true;
            // mark peerId to find it later at peerLeave event
            newAudio.setAttribute('data-peer-id', stream.peerId);
            remoteVideos.append(newAudio);
            await newAudio.play().catch(console.error);
        });
        // 画面共有用にstreamを受けるのに使用する
        peer.on('call', (mediaConnection)=>{
            console.log('Skyway called');
            // このanswerで答えることでこの下のstreamを受けることが出来る
            mediaConnection.answer(getLocalStream());
            mediaConnection.on('stream', async (stream)=>{
                console.log('Skyway call stream');
                // Render remote stream for callee
                const updatedVideo = document.getElementById('video0');
                setVideo(updatedVideo);
                const video = getVideo();
                if (video) {
                    console.log('video connect');
                    video.srcObject = stream;
                    video.playsInline = true;
                    await video.play().catch(console.error);
                } else {
                    console.log('video null');
                }
            });
        });
        //
        room.on('data', ({ data , src  })=>{
            // Show a message sent to the room and who sent
            //      messages.textContent += `${src}: ${data}\n`;
            // debugLog(`${src}: ${data}`);
            if (data === 'screenshare:tell') {
                const fn = getSkywayOnTellScreenShareStart();
                if (fn !== undefined) {
                    fn();
                    return;
                }
            } else if (data === 'screenshare:waitstart') {
                const fn = getSkywayOnTellWaitScreenShare();
                if (fn !== undefined) {
                    fn();
                    return;
                }
            }
            if (data.startsWith('screenshare:')) {
                const paramsScreenShare = data.split(':');
                if (paramsScreenShare[1] === 'start') {
                    const remoteStream = videoStreams.get(src);
                    if (worldViewerWindow.hel_video_is_playing_same_stream(remoteStream)) {
                        return;
                    }
                    // グローバルにhel_onReceiveNoticeScreenShareStartが定義されていた場合に実行する
                    if (typeof worldViewerWindow.hel_onReceiveNoticeScreenShareStart === 'function') {
                        worldViewerWindow.hel_onReceiveNoticeScreenShareStart(src, remoteStream, paramsScreenShare[2], paramsScreenShare[3]);
                    }
                    // 予約
                    this.reserveRemotoVideoStream(remoteStream, paramsScreenShare[2], paramsScreenShare[3]);
                    // HeliScriptのコールバックを呼び出す
                    worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_OnReceivedStartScreenShare, "");
                }
                if (paramsScreenShare[1] === 'stop') {
                    // グローバルにhel_onReceiveNoticeScreenShareStopが定義されていた場合に実行する
                    if (typeof worldViewerWindow.hel_onReceiveNoticeScreenShareStop === 'function') {
                        worldViewerWindow.hel_onReceiveNoticeScreenShareStop(src);
                    } else {
                        worldViewerWindow.hel_video_stop();
                        // HeliScriptのコールバックを呼び出す
                        worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_OnReceivedStopScreenShare, "");
                    }
                }
            }
            worldViewerWindow.hel_skyway_receive_data('data', src, data);
            // dataが 'msg:' の場合は、チャットメッセージ。なのでチャットのバッジ更新を行う。
            if (data.startsWith('msg:')) {
                worldViewerWindow.hel_chatbadge_ui_update(); // チャットログバッジのUI更新
            }
        });
        // for closing room members
        room.on('peerLeave', (peerId)=>{
            worldViewerWindow.hel_skyway_release_player(peerId);
            const remoteVideo = remoteVideos.querySelector(`[data-peer-id="${peerId}"]`);
            remoteVideo.srcObject.getTracks().forEach((track)=>track.stop());
            remoteVideo.srcObject = null;
            remoteVideo.remove();
            if (videoStreams.has(peerId)) {
                // ビデオストリームの除去
                videoStreams.delete(peerId);
                if (typeof worldViewerWindow.hel_onReceiveNoticeScreenShareStop === 'function') {
                    worldViewerWindow.hel_onReceiveNoticeScreenShareStop(peerId);
                }
            }
            // messages.textContent += `=== ${peerId} left ===\n`;
            // worldViewerWindow.hel_skyway_add_text_chat("", `${peerId} leaved`);
            worldViewerWindow.hel_skyway_receive_data('leave', peerId, '');
        });
        // for closing myself
        room.once('close', ()=>{
            Array.from(remoteVideos.children).forEach((remoteVideo)=>{
                remoteVideo.srcObject.getTracks().forEach((track)=>track.stop());
                remoteVideo.srcObject = null;
                remoteVideo.remove();
            });
            this.releaseAllPlayer();
        });
        // roomidをURLに反映する
        worldViewerWindow.hel_net_replace_room_url_with_roomid(roomid);
    }
    joinRoomAfterPeerOpen(roomid) {
        const peer = this.getPeer();
        if (peer == null) {
            throw new Error('peer has not been set yet');
        }
        peer.on('open', ()=>{
            this.joinRoom(roomid);
        });
    }
    leaveRoom() {
        if (this.m_Room == null) return;
        this.m_Room.close();
        this.m_Room = null;
    }
    setSkywayRoom(meshRoom) {
        this.m_Room = meshRoom;
    }
    static addSubDomainRoomId(roomid) {
        const parts = location.hostname.split('.');
        const subdomain = parts.shift();
        const skywayRoomId = subdomain + '_' + roomid;
        return skywayRoomId;
    }
    // プレイヤー
    createPlayer(peerId) {
        const skywayPlayer = new CHELSkywayPlayer(peerId, getMixerRealSettingAt(HEL_AUDIO_TYPE_VOICE));
        const skywayPlayerList = this.m_PlayerList;
        for(let n = 0; n < skywayPlayerList.length; n++){
            if (skywayPlayerList[n] === null) {
                this.setPlayerList(skywayPlayer, n);
                return;
            }
        }
        skywayPlayerList.push(skywayPlayer);
    }
    releasePlayer(peerId) {
        const skywayPlayerList = this.m_PlayerList;
        for(let n = 0; n < skywayPlayerList.length; n++){
            const skywayPlayer = skywayPlayerList[n];
            if (skywayPlayer === null) {
                continue;
            }
            if (skywayPlayer.getPeerId() === peerId) {
                skywayPlayer.release();
                this.setPlayerList(null, n);
                return;
            }
        }
    }
    setPlayerVoiceMute(peerId, mute) {
        const Player = this.getPlayer(peerId);
        if (Player === null) return;
        // eslint-disable-next-line new-cap
        Player.SetMute(mute);
    }
    setPlayerVoiceAttenuate(peerId, volume) {
        const Player = this.getPlayer(peerId);
        if (Player === null) return;
        // eslint-disable-next-line new-cap
        Player.SetVoiceAttenuate(volume);
    }
    setAllPlayerVoiceVolume(volume) {
        const skywayPlayerList = this.m_PlayerList;
        for(let n = 0; n < skywayPlayerList.length; n++){
            const skywayPlayer = skywayPlayerList[n];
            if (skywayPlayer === null) {
                continue;
            }
            skywayPlayer.setVolume(volume);
        }
    }
    setPlayerStream(stream) {
        if (!stream.peerId) {
            debugLog('stream.peerId not');
            return;
        }
        let player = this.getPlayer(stream.peerId);
        if (player === null) {
            this.createPlayer(stream.peerId);
            player = this.getPlayer(stream.peerId);
            if (player === null) {
                debugLog('CreatePlayer error : ' + stream.peerId);
                return;
            }
        }
        player.setStream(stream);
    }
    getPlayer(peerId) {
        const skywayPlayerList = this.m_PlayerList;
        for(let n = 0; n < skywayPlayerList.length; n++){
            const skywayPlayer = skywayPlayerList[n];
            if (skywayPlayer === null) {
                continue;
            }
            if (skywayPlayer.getPeerId() === peerId) {
                return skywayPlayer;
            }
        }
        return null;
    }
    sendMyPlayerInfoToAllPlayer() {
        if (!this.isConnected()) return;
        worldViewerWindow.hel_skyway_send_data('join:' + getSkywayName() + ':' + getSkywayAvatarNumberForSend() + ':' + (getSkywayStartToggle() ? 1 : 0) + ':' + (getSkywayUseCustomAvatarIcon() ? 1 : 0));
        // アバター情報を送信する
        if (getSkywayAvatarNumberForSend() !== -1) {
            worldViewerWindow.hel_skyway_send_data('avatar:' + getSkywayAvatarNumberForSend());
        }
        // カスタムアバターアイコンのURLを送信する
        if (getSkywayUseCustomAvatarIcon() && getSkywayCustomAvatarIconURL() !== '') {
            worldViewerWindow.hel_skyway_send_data('customavataricon:' + getSkywayCustomAvatarIconURL());
        }
        // カスタムユーザーデータを送信する
        worldViewerWindow.hel_skyway_myinfo_bridge_call();
    }
    // ハートビート
    sendHeartBeat() {
        if (!this.isInRoom()) return;
        const numOfPlayers = 1 + worldViewerWindow.getNumOfPlayers(this.getSkywayRoom());
        // console.log("hel_skyway_send_heartbeat " + NumofPlayer);
        worldViewerWindow.sendHeartbeat(getSkyRoomId(), numOfPlayers);
    }
    // 低レベルデータ送信
    sendData(param) {
        const room = this.getSkywayRoom();
        if (room == null) {
            return;
        }
        room.send(param);
    }
    // 画面共有
    async connectWithDisplayMedia() {
        const localVideo = document.getElementById('js-local-stream');
        // const remoteVideos = document.getElementById('js-remote-streams') as HTMLVideoElement;
        //
        // const sdkSrc = document.querySelector('script[src*=skyway]');
        if (!navigator.mediaDevices) {
            debugLog('navigator.mediaDevices not found');
            return;
        }
        const localAudioStream = await CHeliSkyway.setLocalAudioStreamBy();
        const localVideoStream = await navigator.mediaDevices.getDisplayMedia({
            audio: false,
            video: {
                width: {
                    ideal: 1280
                },
                height: {
                    ideal: 720
                },
                frameRate: {
                    ideal: 30
                }
            }
        }).catch(console.error);
        localAudioStream.addTrack(localVideoStream.getVideoTracks()[0]);
        // default mic mute
        worldViewerWindow.hel_skyway_set_mic_state(false);
        // Render local stream
        localVideo.muted = true;
        localVideo.srcObject = localAudioStream;
        localVideo.playsInline = true;
        await localVideo.play().catch(console.error);
        // eslint-disable-next-line require-atomic-updates
        this.m_Peer = new Peer({
            key: worldViewerWindow.g_SKYWAY_KEY,
            debug: 0
        });
        this.m_Peer.on('error', console.error);
        this.m_Peer.on('open', ()=>{
            worldViewerWindow.hel_skyway_join();
        });
    }
    async startScreenShare(videoItemName, videoMaterialName, useCamera, useAudio) {
        if (!navigator.mediaDevices) {
            debugLog('navigator.mediaDevices not found');
            return;
        }
        let localVideoStream;
        if (useCamera) {
            localVideoStream = await navigator.mediaDevices.getUserMedia({
                audio: useAudio,
                video: true
            }).catch(console.error);
        } else {
            localVideoStream = await CHeliSkyway.setLocalScreenShareStreamBy(useAudio);
        }
        if (!localVideoStream) {
            return;
        }
        // Webブラウザから画面共有停止したときのイベントを設定する
        localVideoStream.getVideoTracks()[0].addEventListener('ended', ()=>{
            worldViewerWindow.hel_skyway_stop_screen_sharing_via_room();
        });
        //
        this.replaceLocalStream(localVideoStream);
        // Render local stream
        // 動画の再生
        worldViewerWindow.hel_video_stop();
        helcore_video_play(videoItemName, videoMaterialName, './Video/blankVideo.mp4', true, false, false);
        const video = getVideo();
        if (video !== undefined) {
            const previewVideoStream = new MediaStream();
            previewVideoStream.addTrack(localVideoStream.getVideoTracks()[0]);
            video.srcObject = previewVideoStream;
            await video.play();
        }
        this.setScreenShareCurrentInfo(videoItemName, videoMaterialName);
        setTimeout(()=>{
            // 全ユーザーに画面共有の開始を通知する
            this.sendScreenShareStart();
        }, 1000);
        // グローバルに hel_onScreenShareStart が定義されていた場合に実行する
        if (typeof worldViewerWindow.hel_onScreenShareStart === 'function') {
            worldViewerWindow.hel_onScreenShareStart();
        }
        // HeliScriptのコールバックを呼び出す
        worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_OnStartScreenShare, "");
    }
    async stopScreenShare() {
        worldViewerWindow.hel_video_stop();
        const localStream = getLocalStream();
        if (localStream === undefined) {
            return;
        }
        localStream.getVideoTracks().forEach((track)=>track.stop());
        localStream.removeTrack(localStream.getVideoTracks()[0]);
        const canvas = document.createElement('canvas');
        canvas.getContext('2d');
        const dummyTrack = canvas.captureStream().getVideoTracks()[0];
        localStream.addTrack(dummyTrack);
        setLocalStream(localStream);
        this.replaceLocalStream(localStream);
        worldViewerWindow.hel_skyway_send_data(`screenshare:stop`);
        // HeliScriptのコールバックを呼び出す
        worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_OnStopScreenShare, "");
    }
    setScreenShareCurrentInfo(videoItemName, videoMaterialName) {
        this.m_ScreenShare_CurrentVideoItemName = videoItemName;
        this.m_ScreenShare_CurrentVideoMaterialName = videoMaterialName;
    }
    sendScreenShareStart() {
        if (this.m_ScreenShare_CurrentVideoItemName === "") return;
        if (this.m_ScreenShare_CurrentVideoMaterialName === "") return;
        worldViewerWindow.hel_skyway_send_data(`screenshare:start:${this.m_ScreenShare_CurrentVideoItemName}:${this.m_ScreenShare_CurrentVideoMaterialName}`);
    }
    reserveRemotoVideoStream(remoteVideoStream, videoItemName, videoMaterialName) {
        this.m_skyway_reseved_remoteVideoStream = remoteVideoStream;
        this.m_skyway_reseved_videoItemName = videoItemName;
        this.m_skyway_reseved_videoMaterialName = videoMaterialName;
    }
    playScreenShare() {
        worldViewerWindow.hel_skyway_send_data('screenshare:waitstart');
        if (this.m_Room == null) return;
        this.m_Room.on('stream', (stream)=>{
            const video = getVideo();
            if (video !== undefined) {
                if (video.srcObject !== stream) {
                    const videoTracks = stream.getVideoTracks();
                    if (videoTracks.length > 0) {
                        video.srcObject = stream;
                        video.playsInline = true;
                    }
                }
            }
        });
    }
    playScreenShareReserved() {
        worldViewerWindow.hel_skyway_play_remote_video_stream(this.m_skyway_reseved_remoteVideoStream, this.m_skyway_reseved_videoItemName, this.m_skyway_reseved_videoMaterialName);
    }
    // コールバック
    setCallback(callback) {
        this.m_IHeliNetworkCallback = callback;
    }
    // Skyway専用
    getPeer() {
        return this.m_Peer;
    }
    getRoom() {
        return this.m_Room;
    }
    //
    static async setLocalAudioStreamWithDummyVideoBy() {
        const localStream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false
        }).catch(console.error);
        if (localStream === undefined || localStream === null) {
            return null;
        }
        const canvas = document.createElement('canvas');
        canvas.getContext('2d');
        localStream.addTrack(canvas.captureStream().getVideoTracks()[0]);
        setLocalStream(localStream);
        return localStream;
    }
    static async setLocalAudioStreamBy() {
        const localStream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false
        }).catch(console.error);
        setLocalStream(localStream);
        return localStream;
    }
    static async setLocalScreenShareStreamBy(useAudio) {
        const localStream = getLocalStream();
        const localScreenStream = await navigator.mediaDevices.getDisplayMedia({
            audio: useAudio,
            video: {
                width: {
                    ideal: 1280
                },
                height: {
                    ideal: 720
                },
                frameRate: {
                    ideal: 30
                }
            }
        }).catch(console.error);
        if (!localScreenStream || localStream === undefined) {
            return null;
        }
        localStream.removeTrack(localStream.getVideoTracks()[0]);
        localStream.addTrack(localScreenStream.getVideoTracks()[0]);
        if (useAudio) {
            localStream.addTrack(localScreenStream.getAudioTracks()[0]);
        }
        setLocalStream(localStream);
        return localStream;
    }
    replaceLocalStream(stream) {
        if (this.m_Room == null) {
            console.log("replaceLocalStream : m_room is null");
            return;
        }
        this.m_Room.replaceStream(stream);
        setLocalStream(stream);
    }
    static async playLocalStream(localStream) {
        const localVideo = CHeliSkyway.getLocalVideoElement();
        localVideo.muted = true;
        localVideo.srcObject = localStream;
        localVideo.playsInline = true;
        await localVideo.play().catch(console.error);
    }
    static resetLocalStream() {
        const localVideo = CHeliSkyway.getLocalVideoElement();
        localVideo.srcObject = null;
        localVideo.load();
    }
    static getLocalVideoElement() {
        return document.getElementById('js-local-stream');
    }
    // プレイヤーリスト
    setPlayerList(skywayPlayer, index) {
        this.m_PlayerList[index] = skywayPlayer;
    }
    releaseAllPlayer() {
        const skywayPlayerList = this.m_PlayerList;
        for(let n = 0; n < skywayPlayerList.length; n++){
            const skywayPlayer = skywayPlayerList[n];
            if (skywayPlayer === null) {
                continue;
            }
            worldViewerWindow.hel_skyway_receive_data('leave', skywayPlayer.getPeerId(), '');
            skywayPlayer.release();
            this.setPlayerList(null, n);
        }
    }
    // ルーム
    getSkywayRoom() {
        return this.m_Room;
    }
    isInRoom() {
        return this.m_Room != null;
    }
    // コンストラクタ
    constructor(){
        _defineProperty(this, "m_Peer", null);
        // マイク許可状態
        _defineProperty(this, "m_MicPermissionState", EHeliMicPermissionState.Prompt);
        // ルーム
        _defineProperty(this, "m_Room", null);
        // プレイヤーリスト
        _defineProperty(this, "m_PlayerList", []);
        // 画面共有
        _defineProperty(this, "m_ScreenShare_CurrentVideoItemName", "");
        _defineProperty(this, "m_ScreenShare_CurrentVideoMaterialName", "");
        _defineProperty(this, "m_skyway_reseved_remoteVideoStream", null);
        _defineProperty(this, "m_skyway_reseved_videoItemName", "");
        _defineProperty(this, "m_skyway_reseved_videoMaterialName", "");
        // コールバック
        _defineProperty(this, "m_IHeliNetworkCallback", null);
    }
}
